import * as GmapVue from 'gmap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from 'vue'

Vue.use(VueGoogleMaps, {
    installComponents: true,
})

Vue.use(GmapVue, {
    load: {
        key: process.env.MIX_GOOGLE_MAP_API_KEY,
        libraries: 'places,geometry,drawing,visualization',
        v: '3.62',
    },
    installComponents: true
})
